var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-provider',{attrs:{"rules":_vm.validations},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-text-field',{attrs:{"value":_vm.value,"label":_vm.field.label,"type":"time","required":"","error-messages":errors,"color":"#005c7b"},on:{"input":_vm.onChange}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }